import { supabase } from './supabase';

const functionsBase = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1`;

export function getSteamLoginUrl() {
  const redirectTo = window.location.origin;
  const params = new URLSearchParams({ redirect_to: redirectTo });
  return `${functionsBase}/steam-auth/start?${params.toString()}`;
}

async function invokeFunction(name) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    throw new Error('Not authenticated');
  }

  const response = await fetch(`${functionsBase}/${name}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      'Content-Type': 'application/json',
    },
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.error || `Request failed (${response.status})`);
  }

  return body;
}

export function syncActivity() {
  return invokeFunction('sync-steam-activity');
}

export function syncFriends() {
  return invokeFunction('sync-steam-friends');
}
